"use client";

import { useAppSelector } from "@/store/hooks";
import Image from "next/image";

export default function EditorialHeader() {
  const { data } = useAppSelector((state) => state.content);

  if (!data?.chefsSpecial || !data.chefsSpecial.editorialHeader) return null;

  const { eyebrow, titleLines, description, stats, imageSrc, caption } =
    data.chefsSpecial.editorialHeader || {};

  return (
    <div className="max-w-7xl mx-auto mb-20 px-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div className="relative z-10">
          <div className="mb-8">
            <span className="text-sm font-medium text-black/60 tracking-widest uppercase mb-4 block">
              {eyebrow}
            </span>
            <h2 className="text-6xl md:text-8xl lg:text-9xl font-bold text-black leading-none mb-6">
              {titleLines.map((line) => (
                <span
                  key={`${line.text}-${line.italic ? "i" : "n"}`}
                  className={line.italic ? "italic font-light block" : "block"}
                >
                  {line.text}
                </span>
              ))}
            </h2>
          </div>
          <div className="w-24 h-1 bg-black mb-8" />
          <p className="text-xl text-black/70 leading-relaxed mb-8">
            {description}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-sm text-black/50 font-medium">
              {stats[0]}
            </span>
            <div className="w-8 h-px bg-black/30" />
            <span className="text-sm text-black/50 font-medium">
              {stats[1]}
            </span>
          </div>
        </div>
        <div className="relative isolate z-0">
          <div className="absolute -top-8 -left-8 w-full h-full border-2 border-black/10 rounded-2xl" />
          <div className="relative w-full h-96 rounded-2xl overflow-hidden">
            <Image
              src={imageSrc}
              alt="Chef at work"
              fill
              className="object-cover"
              unoptimized
            />
            <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg">
              <span className="text-sm font-medium text-black">{caption}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
